import {TrustAccountActivityType} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {ActivityFeedRowLayout} from '../ActivityFeedRowLayout';
import {castMetadata} from './metadata.utils';

import type {BeneficiaryChangeMetadata, TrustAccountActivityDTO} from '@sollapay/types';

interface BeneficiaryRowProps {
  activity: TrustAccountActivityDTO;
}

export function BeneficiaryRow({activity}: BeneficiaryRowProps) {
  const {t} = useTranslation('trustAccounts');
  const meta = castMetadata<BeneficiaryChangeMetadata>(activity);
  const isRemoved = activity.activityType === TrustAccountActivityType.BENEFICIARY_REMOVED;

  return (
    <ActivityFeedRowLayout
      icon={isRemoved ? 'sollapay:remove-buyer' : 'sollapay:buyer'}
      title={t(`view.activity.activityType.${activity.activityType}`)}
      subtitle={meta?.role ? t(`partyRole.${meta.role}`) : null}
      actorName={meta?.beneficiaryName ?? null}
      createdAt={activity.createdAt}
    />
  );
}
